<template>
  <div class="container-statistics">
    <span v-if="showOption.includes('totalAmount')">总金额: {{ totalAmount }}</span>
    <span v-if="showOption.includes('paidAmount')">已付金额: {{ paidAmount }}</span>
    <span v-if="showOption.includes('deductionAmount')">抵扣金额: {{ deductionAmount }}</span>
    <span v-if="showOption.includes('remainingAmount')">待付剩余金额: {{ remainingAmount }}</span>
  </div>
</template>

<script>
export default {
  name: "AmountStatistics",
  props: {
    showOption:{
        type:Array,
        default: () => [
            "totalAmount",
            "paidAmount",
            "deductionAmount",
            "remainingAmount",
        ],
    },
    totalAmount: {
      type: Number,
      default: 0,
    },
    paidAmount: {
      type: Number,
      default: 0,
    },
    deductionAmount: {
      type: Number,
      default: 0,
    },
    remainingAmount: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.container-statistics {
  margin-bottom: 10px;

  span {
    margin-right: 15px;
    font-weight: bold;
  }
}
</style>
